<template>
  <VpVueForm
    :fields="fields"
    :id="id"
    class="vp-p-4"
    :save="save"
    :get="get"
    :del="del"
    width="500px"
    cache="whatsappCloudApiBroadcast"
    :collection-cache="'whatsappExtensionBroadcasts'"
    feature="WHATSAPP_BROADCAST"
    ref="broadcastForm"
  >
    <template #default="{ state, response, isCreating }">
      <VpField rules="required" name="Broadcast Name" label="Broadcast Name">
        <VpInput>
          <VpTextBox v-model="state.name" />
        </VpInput>
      </VpField>

      <VpField label="Select Contacts" note="">
        <div
          class="vp-border-gray-200 vp-border vp-rounded-md vp-overflow-hidden"
        >
          <VpLoaderContainer overlay :loading="loading">
            <div class="vp-p-5 vp-space-y-4">
              <VpField
                label="Tags"
                :note="
                  isCreating
                    ? `Contact having any of the tags you select will be added to broadcast.`
                    : ``
                "
              >
                <TagsInput
                  v-if="isCreating"
                  type="contact"
                  v-model="state.tagIds"
                  @input="getTotalContactCount(state)"
                />

                <TagsDisplay
                  v-else-if="response.tags.length"
                  :value="response.tags"
                />

                <p v-else class="vp-text-xs vp-text-gray-500">
                  No tags are selected.
                </p>
              </VpField>
              <VpField
                label="Funnels"
                :note="
                  isCreating
                    ? `Contact having any of the funnel you select will be added to broadcast.`
                    : ``
                "
              >
                <FunnelMultiInput
                  v-if="isCreating"
                  v-model="state.funnelIds"
                  @input="getTotalContactCount(state)"
                />
                <div
                  class="vp-flex vp-flex-wrap vp-gap-1"
                  v-else-if="response.funnels.length"
                >
                  <FunnelDisplay
                    v-for="item in response.funnels"
                    :key="item.id"
                    :value="item"
                  />
                </div>
                <p v-else class="vp-text-xs vp-text-gray-500">
                  No funnel is selected.
                </p>
              </VpField>
              <div>
                <p class="vp-text-primary-500">
                  Selected Contacts:
                  {{
                    isCreating ? totalContacts : response?.summary.recipients
                  }}
                </p>
                <p class="vp-text-xs vp-text-warning-500">
                  To avoid your number being blocked by WhatsApp, we recommend
                  to add upto 100 contacts to broadcast list.
                </p>
              </div>
            </div>
          </VpLoaderContainer>
        </div>
      </VpField>

      <template>
        <VpField
          rules="required"
          label="Select Quick Reply"
          name="Select Quick Reply"
          note="You can broadcast simple message, single image with text or only send one document file using this feature."
        >
          <VpSelectRequest
            v-model.number="state.quickReplyId"
            :request="getQuickReplies"
          />
        </VpField>
      </template>
    </template>
  </VpVueForm>
</template>

<script>
import { OpenInNew } from "icons/icons.js";
import TagsDisplay from "components/src/tags/display.vue";
import TagsInput from "components/src/tags/input.vue";
import FunnelDisplay from "components/src/funnel/display.vue";
import FunnelMultiInput from "components/src/funnel/multi-input.vue";

import getExt from "./get.gql";
import quickReplies from "./quick-replies.gql";
import upsertExt from "./upsert.gql";
import getContacts from "../contacts-count.gql";
import move from "../move.gql";

export default {
  icons: {
    OpenInNew,
  },
  props: {
    id: [Number, String],
  },

  components: {
    FunnelDisplay,
    TagsDisplay,
    TagsInput,
    FunnelMultiInput,
  },

  data() {
    return {
      totalContacts: 0,
      loading: false,
      isSaving: false,
      fields: [
        "name",
        "quickReplyId",
        { name: "tagIds", value: [] },
        { name: "funnelIds", value: [] },
      ],
    };
  },

  computed: {},

  mounted() {
    if (this.id == "+") {
      this.getTotalContactCount(null);
    }
  },

  methods: {
    getQuickReplies() {
      return this.$query(quickReplies).then(
        ({
          data: {
            quickReplies: { data },
          },
        }) => {
          return data.map((item) => ({
            label: item.name,
            value: item.id,
          }));
        }
      );
    },

    getTotalContactCount(state) {
      this.loading = true;
      this.$query(getContacts, {
        filters: {
          tagIds: state?.tagIds.length ? state?.tagIds : null,
          funnelIds: state?.funnelIds.length ? state?.funnelIds : null,
        },
      })
        .then(({ data: { contacts } }) => {
          this.totalContacts = contacts.pagination.total;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    get(id) {
      return this.$query(getExt, {
        id,
      }).then(({ data }) => {
        const broadcast = data.whatsappExtensionBroadcast;

        this.$emit("item", broadcast);

        return {
          values: {
            ...broadcast,
            funnelIds: broadcast.funnels?.map((item) => item.id),
            tagIds: broadcast.tags?.map((item) => item.id),
            quickReplyId: broadcast.quickReply.id,
          },
          res: data,
        };
      });
    },

    save(id, data) {
      return this.$mutate(upsertExt, {
        id,
        input: data,
      })
        .then(({ data }) => {
          this.$router.push({
            name: "whatsapp-extension-broadcast",
            params: {
              id: data.upsertWhatsappExtensionBroadcast.id,
            },
          });

          return data;
        })
        .catch(() => {});
    },

    del(id, action) {
      return this.$mutate(move, {
        id: parseInt(id),
        action,
      }).then(() => {
        this.$router.push({
          name: "whatsapp-extension-broadcasts",
        });
      });
    },
  },
};
</script>
